import { cva } from 'class-variance-authority';

export const select = cva(
  [
    'pb-2',
    'h-9',
    'ml-[-4px]',
    'focus:ring-0',
    'outline-0',
    'font-medium',
    'text-inherit',
    'disabled:text-neutral-500',
    'disabled:bg-transparent',
    'disabled:opacity-100',
  ],
  {
    variants: {
      placeholder: {
        true: ['text-neutral-500'],
        false: [],
      },
    },
  }
);

export const container = cva(
  [
    'group',
    'flex',
    'flex-col',
    'text-blue-950',
    'border-0',
    'border-b-[1px]',
    'relative',
    'pt-5',
    'pb-[1px]',
  ],
  {
    variants: {
      error: {
        true: ['border-red-400'],
        false: [],
      },
      disabled: {
        true: [
          'border-neutral-400',
          'focus-within:border-neutral-400',
          'focus-within:border-b',
          'hover:border-neutral-400',
          'hover:border-b',
        ],
        false: [
          'focus-within:border-b-[2px]',
          'hover:border-b-[2px]',
          'hover:pb-0',
          'focus:pb-0',
        ],
      },
    },
    compoundVariants: [
      {
        disabled: false,
        error: false,
        className: [
          'border-neutral-700',
          'focus-within:border-primary-600',
          'hover:border-primary-600',
        ],
      },
    ],
  }
);

export const label = cva(['text-sm'], {
  variants: {
    disabled: {
      true: ['text-neutral-500'],
      false: ['text-inherit'],
    },
  },
});
